import { add, isAfter, isEqual } from "date-fns"
import { IsValidCheck } from "./types"

export const isOffCoverDateWithinLast14DaysError = `Can't take something off cover more than 14 days after the off cover date`
export const isOffCoverDateWithinLast14Days: IsValidCheck = (entry, currentEntries, policyDuration, hasAdminAccess) => {
  const currentEntry = currentEntries?.find((it) => it.uniqueRef === entry.uniqueRef)
  if (
    hasAdminAccess ||
    !entry.uniqueRef ||
    !entry.offCoverDate ||
    !currentEntry ||
    !currentEntry.offCoverDate ||
    isEqual(new Date(currentEntry.offCoverDate as string), new Date(entry.offCoverDate as string))
  )
    return undefined

  const now = new Date()
  const offCoverPlus14days = add(new Date(currentEntry.offCoverDate as string), { days: 14 })

  return isAfter(offCoverPlus14days, now)
}
